import { Injectable } from '@angular/core';
import { Resource, Service } from 'ngx-jsonapi';

export class SystemInformation extends Resource {
    public type: string = 'system_information';
    public attributes: {
        description: string;
        pros: string;
        cons: string;
        time_average: number;
        trend_by_day: string;
        trend_by_weekday: string;
        alternative_system_ids: string;
        on_time_percent: string;
        volume: number;
        qty_user_per_system: number;
        qty_sent_transaction: number;
        qty_coordinated_transaction: number;
        alternative_name: string;
        tags: string;
    } = {
        description: '',
        pros: '',
        cons: '',
        time_average: 0,
        trend_by_day: '',
        trend_by_weekday: '',
        alternative_system_ids: '',
        on_time_percent: '',
        volume: 0,
        qty_user_per_system: 0,
        qty_sent_transaction: 0,
        qty_coordinated_transaction: 0,
        alternative_name: '',
        tags: ''
    };
}

@Injectable({
    providedIn: 'root'
})
export class SystemInformationService extends Service<SystemInformation> {
    public resource: typeof SystemInformation = SystemInformation;
    public type: string = 'system_information';

    public constructor() {
        super();
        this.register();
    }
}
